import { render } from "./CreateArtistPage.vue?vue&type=template&id=23c340d0"
import script from "./CreateArtistPage.vue?vue&type=script&lang=js"
export * from "./CreateArtistPage.vue?vue&type=script&lang=js"

import "./CreateArtistPage.vue?vue&type=style&index=0&id=23c340d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__